import axios from 'axios';
import { message as antMessage } from 'antd';
import {getParameterByName, removeURLParameter, hrefChangeUrl} from "@/utils/utils";
import _ from 'lodash';
//处理有小数点的位数
function transformUrl(config) {
  if (!_.get(config, 'params', false) && !_.get(config, 'data', false))
    return config;
  let reg = /{\w+}/g;
  let url = config.url;
  let res = url.match(reg);
  let params = {};
  if (_.isEmpty(res)) return config;
  let isData = _.get(config, 'data', false);
  if (isData) {
    params = { ...config.data };
  } else {
    params = { ...config.params };
  }
  for (let index = 0; index < res.length; index++) {
    let item = res[index];
    let param = item.replace(/[{}]/g, '');
    if (params[param]) {
      url = url.replace(item, params[param]);
      delete params[param];
    }
  }
  if (isData) {
    return {
      ...config,
      url,
      data: params,
    };
  } else {
    return {
      ...config,
      url,
      params,
    };
  }
}

antMessage.config({ maxCount: 1 });
// api请求实例
// eslint-disable-next-line no-undef 
// 调试企微使用QW_URL 独立版crmUrl
const domain = process.env.NODE_ENV === 'development' ? 'https://lixiao-test.ikcrm.com' : location.origin;

const instance = axios.create({
  baseURL: domain + '/api',
  timeout: 20000,
});

instance.interceptors.request.use(
  config => {
      // config.headers["Crm-Platform-Type"] = window.crm_platform_type;
      config.headers["authorization"] = `Token token="${window.current_user_token}"`;
      config = { ...transformUrl(config) };
    return config;
  },
  err => Promise.reject(err)
);
// 响应拦截器
instance.interceptors.response.use(function(res) {
  const { code, message, requestId } = res.data;
  const errorCode = getParameterByName('errorCode')
  if(code !== 0) {
    // http://wiki.weiwenjia.com:53435/confluence/pages/viewpage.action?pageId=145555630
    // 错误map文件 constant/errorCode.js

    if(code === 500){
      //code500为后端某些接口有逻辑问题，没有传回正常的7位错误code，提示后返回数据给接口调用处特殊处理
      antMessage.error(message);
    }else{
      return Promise.reject(res.data);
    }
  } else {
    if (errorCode) {
      // window.location.href = removeURLParameter(window.location.href, errorCode);
      hrefChangeUrl(removeURLParameter(window.location.href, errorCode));
    }
  }
  return {
    success: code === 0,
    requestId: requestId,
    ...res.data
  };
}, function (error) {
  console.log(error);
  // 对响应错误做点什么
  return Promise.reject(error);
});

export default instance
